module.exports = __webpack_public_path__ + "img/zhishu-icon.3218eb89.png";